import React from 'react';
import { Box } from '@mui/material';

import { MaterialPropertyValuePair } from '@paragon/client-tools';
import { MemberLine } from '@paragon/contract-library';

import { getReferenceLineShortNamesByGuidForActiveComponent } from '../../../../store/selectors/getReferenceLineShortNamesByGuidForActiveComponentSelector';
import { useAppSelector } from '../../../hooks';

interface Props {
  line: MemberLine;
}

const MemberLineProperties = (props: Props) => {
  const { line } = props;

  const lineName = useAppSelector(
    (state) => getReferenceLineShortNamesByGuidForActiveComponent(state)?.get(line.guid) ?? null,
  );
  if (lineName == null) return null;

  return (
    <Box sx={{ display: 'flex' }}>
      <MaterialPropertyValuePair value={lineName} property="Member geometry" />
      <MaterialPropertyValuePair value={line.lineLocation} property="Line location" />
    </Box>
  );
};

export default MemberLineProperties;
